exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nominee-category {\n  width: 100%;\n}\n.nominee-category a,\n.nominee-category a:hover,\n.nominee-category a:active {\n  color: black;\n}\n.nominee-category a strong,\n.nominee-category a:hover strong,\n.nominee-category a:active strong {\n  color: black;\n}\n.nominee-category img {\n  cursor: pointer;\n}\n", ""]);

// exports
